import React, {useEffect, useRef, useState} from 'react';
import VisitRequest from './components/VisitRequest';
import VisitorList from './components/VisitorList';
import {FormattedMessage, useIntl} from "react-intl";
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {VisitRequestApi} from "../../../../../modules/vms/api/VisitRequestApi";
import {MessageUtils} from "../../../../../utils/MessageUtils";
import {Button, Stack} from "@mui/material";
import SubmitButton from "../../../../../components/buttons/SubmitButton";
import LoadingBackdrop from "../../../../../components/LoadingBackdrop";
import {VisitRequestClassify} from "../../../../../modules/vms/enums/VisitRequestClassify";
import dayjs from "dayjs";
import {Formats} from "../../../../../constants/Formats";
import PageTitle from "../../../../../components/PageTitle";
import {ApplySourceType} from "../../../../../modules/vms/enums/ApplySourceType";
import {UserDto} from "../../../../../modules/account/dto/UserDto";
import {UserApi} from "../../../../../modules/account/api/UserApi";

const Index: React.FC = () => {
    const intl = useIntl();

    const [messageMap, setMessageMap] = useState(new Map<string, string>());

    const [visitRequest, setVisitRequest] = useState(new VisitRequestDto());
    const [currentUser, setCurrentUser] = useState(new UserDto());
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchSessionUser();
    }, []);

    const fetchSessionUser = async () => {
        const responseResult = await UserApi.getSessionUser();
        if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
            setCurrentUser(responseResult.data);
            handleInitRequest(responseResult.data);
        }
    };

    const handleSubmit = async () => {
        if (!validate()) {
            return;
        }
        setLoading(true);
        for (let visitor of visitRequest.visitors) {
            if (visitor.attachFilesArray.length > 0) {
                visitor.attachFiles = JSON.stringify(visitor.attachFilesArray);
            }
        }
        const responseResult = await VisitRequestApi.inviteVisitRequest(visitRequest);
        if (responseResult.status === HttpStatus.SUCCESS) {
            MessageUtils.success(intl.formatMessage({id: 'VMS_VISIT_REQUEST_INVITE_SUCCESS'}));
            handleInitRequest(currentUser);
        }
        setLoading(false);
    };

    const handleInitRequest = (currentUser: UserDto) => {
        const newVisitRequest = new VisitRequestDto();
        newVisitRequest.applySourceType = ApplySourceType.Enum.EmployeeWeb;
        newVisitRequest.classify = VisitRequestClassify.Enum.Construction;
        newVisitRequest.arriveStartDate = dayjs().format(Formats.DATE_SIMPLE);
        newVisitRequest.arriveEndDate = newVisitRequest.arriveStartDate;
        newVisitRequest.arriveStartTime = '080000';
        newVisitRequest.arriveEndTime = '200000';
        newVisitRequest.hostFullName = currentUser.fullName;
        newVisitRequest.hostMobile = currentUser.mobile;
        setVisitRequest(newVisitRequest);
    };

    const handleChange = (name: string, value: any) => {
        setVisitRequest({...visitRequest, [name]: value});
    };

    const validate = () => {
        const newMessageMap = new Map<string, string>();
        if (visitRequest.arriveStartDate === '') {
            newMessageMap.set('arriveStartDate', intl.formatMessage({id: 'VMS_VISIT_REQUEST_ARRIVE_DATE_REQUIRED'}));
        }
        if (visitRequest.purpose === '') {
            newMessageMap.set('purpose', intl.formatMessage({id: 'VMS_VISIT_REQUEST_PURPOSE_REQUIRED'}));
        }
        if (visitRequest.places.length <= 0) {
            newMessageMap.set('places', intl.formatMessage({id: 'VMS_VISIT_REQUEST_PLACES_REQUIRED'}));
        }
        if (visitRequest.visitors.length <= 0) {
            newMessageMap.set('visitors', intl.formatMessage({id: 'VMS_VISIT_REQUEST_VISITORS_REQUIRED'}));
        }
        setMessageMap(newMessageMap);
        return newMessageMap.size <= 0;
    };

    return (
        <div>
            <LoadingBackdrop open={loading} onClick={() => setLoading(false)}/>
            <PageTitle title={intl.formatMessage({id: 'VMS_VISIT_REQUEST_CLASSIFY_CONSTRUCTION'})}/>
            <VisitRequest visitRequest={visitRequest} messageMap={messageMap} onChange={handleChange}
                          onChangeVisitRequest={(value) => setVisitRequest(value)}/>
            <br/>
            <VisitorList visitRequest={visitRequest} messageMap={messageMap} onChange={handleChange}/>
            <br/>
            <Stack direction={'row'} spacing={2} justifyContent={'center'} alignItems={'center'}>
                <SubmitButton onClick={handleSubmit}/>
            </Stack>
        </div>
    );
};

export default Index;
